import { useSelector } from "react-redux";

export default function useMobileDetection() {
  return useSelector((state) => state.layout.isMobile);
}
